import { useQuery } from "@tanstack/react-query";
import ConfigHolder from "../../config/ConfigHolder";
import { prepareUrl } from "../../context/WidgetContext";
import { useSettings } from "../../context/SettingsContext";
export const useOAuthLogin = (formContext, options) => {
    const { api_key, widget_id } = useSettings();
    const defaultOptions = Object.assign(Object.assign({}, options), { enabled: false, networkMode: "always", cacheTime: 0, staleTime: 0 });
    return useQuery(Object.assign(Object.assign({}, defaultOptions), { queryKey: ['widget-oauth-login'], queryFn: async ({ signal }) => {
            let url = ConfigHolder.getApiMethodUrl(api_key, widget_id, 'oauthLogin', 'user');
            // let url = new URL(
            //     `/consumer/booking/api/method/oauthLogin`,
            //     ConfigHolder.apiBaseUrl
            // )
            url = prepareUrl(url, 'oauthLogin', api_key, widget_id, {
                token: formContext.getValues('token'),
            });
            const response = await fetch(url.href, {
                signal: signal,
                headers: {
                    'accept': 'application/ld+json',
                }
            });
            return response.json();
        } }));
};
